import React from "react";
import "./SobreNos.css"
import logoblanco from "../../assets/logoleo.png";
import { Link } from "react-router-dom";

import aboutus from "../../assets/contenido/aboutus.jpg";
import aboutus1 from "../../assets/contenido/aboutus1.jpg";
import aboutus34 from "../../assets/contenido/aboutus34.jpg";
import aboutus3 from "../../assets/contenido/aboutus3.jpg";




export default function SobreNos() {
    return (
        <div className="container_aboutus">
        <nav className="navbar navbar-light mb-5" id="encabezado">
                    <Link to="/" className="container-fluid">
                        <img
                        src={logoblanco}
                        width="290"
                        height="550"
                        className="img-fluid d-block mx-auto"
                        alt='logoMingga'
                        />
                    </Link>
                </nav>

                <div className="container-fluid" align="left" id="padding">

                <h3 id="titulo" align="center"> <b>
                Ler e escrever bem, as habilidades fundamentais para alcançar o sucesso acadêmico <br />
                e aproveitar as oportunidades de networking e negócios oferecidas pela internet em todo o mundo




            </b> 
            </h3>

            <br />
            <div align="center">
                <img
                id="imagenajustada"
                className="d-block w-100"
                src={aboutus}
                width="400"
                height="450"
                alt="..."
                />
                </div>

                <br />

                <h3 id="titulo" align="center"> <b>LEO Une communauté mondiale d’affaires et d’éducation<br />
            </b> 
            </h3>
            <br />
                     <p>
            Existe uma lei universal do desenvolvimento: todo progresso e bem-estar de uma sociedade depende da qualidade da educação que sua população recebe. Por isso, os países mais desenvolvidos priorizam ter sistemas educacionais modernos e eficientes que fortaleçam o conhecimento e a competitividade de seus habitantes. Isso é demonstrado pelos testes internacionais PISA da OCDE, que classificam os países de alta renda com os melhores sistemas educacionais do mundo no topo: Cingapura, Canadá, China, Finlândia, Hong Kong, Estônia, Japão e Coreia do Sul.
            </p>
            <p>
            LEO - Clube Mundial de Leitura, é um projeto social que tem como missão promover a leitura, a escrita e o multilinguismo como hábitos que elevam o nível educacional e cultural das pessoas e fortalecem suas habilidades de comunicação, necessárias para o sucesso em suas atividades acadêmicas e na sociedade moderna integrada globalmente pela Internet, que exige a leitura e o uso de quantidades cada vez maiores de informações, além da escrita de conteúdos claros e atraentes para milhões de pessoas ao redor do mundo.
            </p>
                    <p>
            Para cumprir esta missão, a LEO funciona como uma rede digital global, baseada na teoria dos seis graus de separação, que afirma que todas as pessoas do mundo podem ser integradas numa rede com apenas 6 links; Ou seja, com apenas 6 passos podemos entrar em contato com toda a humanidade. Esta é a base das redes sociais Facebook, Twitter, Linkedin, etc., que através da Internet nos permitem, a partir apenas dos nossos conhecidos, criar uma rede com milhares de contactos em todo o mundo, conhecê-los através do seu perfil, histórias e mensagens, e realizar com eles múltiplas atividades culturais, ambientais, empresariais, etc. <br />

            Com esta filosofia, a LEO pretende integrar pessoas de todos os países para trabalharem para alcançar objetivos comuns: melhorar o nosso nível educacional e cultural, fortalecer as capacidades de comunicação e gerar oportunidades de rendimento permanentes que melhorem a nossa qualidade de vida.
 
            </p>
            

            <h3 id="titulo" align="center"> <b>Objectivos <br />
            </b> 
            </h3> 
            <br />      
            <p>
            • Facilitar o acesso aos livros e aumentar as taxas de leitura, para garantir que todos leiam pelo menos um livro por mês, doze livros por ano. <br />
            • Oferecer cenários para que os membros da LEO escrevam e publiquem suas obras em diferentes gêneros, tornando-as conhecidas no país e no mundo. <br />
            • Promover o multilinguismo e as competências comunicativo das pessoas, melhorar suas chances de participação e sucesso na sociedade tecnológica moderna, por meio da Internet. <br />
            • Fortalecer as famílias e as instituições educacionais como ambientes básicos para incutir o hábito da leitura e da escrita nos alunos.


            


            </p>
           

            <br /> 
            <div align="center">
                <img
                id="imagenajustada"
                className="d-block w-100"
                src={aboutus1}
                width="400"
                height="500"
                alt="..."
                />
                </div> 
            <br />
            <h3 id="titulo" align="center"> <b>Associato <br />
            </b> 
            </h3> 

             <p>Qualquer pessoa e estudantes em qualquer país do mundo podem ser membros do Clube Mundial do Livro. Os menores devem ter autorização e tutela de seus pais ou responsáveis, anexando o formulário de autorização de vinculação.          </p>
            <p>
            A associação anual custa apenas US$ 50. Os membros têm acesso gratuito, permanente e gratuito às 15.000 obras de literatura e ciências sociais em cinco idiomas em nossa biblioteca e aos outros programas educacionais e culturais do Clube (obras editoriais, oficina literária, etc.).
            </p>
            

            <br />
            <h3 id="titulo" align="center"> <b>Programas e serviços de parceiros<br />
            </b> 
            </h3>
            <br />
            <p>
            O LEO desenvolveu um pacote de ferramentas pedagógicas com tecnologias web, que permitem de forma eficiente e econômica promover e massificar a leitura, a escrita e o multilinguismo como competências-chave para melhorar o desempenho acadêmico e fazer com que as pessoas aproveitem as oportunidades de contato, educação e negócios oferecidas pela Internet em todo o mundo:
            </p>
           

            <h4 id="titulo" align="left"> <b>1. Promoção da leitura e do multilinguismo
 
            <br />
            </b> 
            </h4> 
            <br />  
            <p>
            A LEO oferece aos seus membros uma biblioteca digital com mais de 15.000 obras de ciências sociais e literatura em 5 idiomas (espanhol, inglês, francês, português e italiano). Mensalmente, 50 novas obras são adicionadas, 600 novos livros por ano. Os membros podem baixar clubleo.net para seu celular, tablet ou PC, para facilitar o acesso às obras. O custo da coleção bibliográfica é estimado em US$ 150.000, mas é gratuito para membros do LEO. (Veja Catálogo)
            </p>
            <p>
            Os membros que vivem em áreas rurais e marginais sem conexão com a internet podem baixar e gravar os trabalhos em seu PC, celular ou tablet para ler e trabalhar sem a necessidade de internet. 
            </p>
            <p>
            Além disso, a LEO desenvolveu o portal web letsallread.com, que oferece artigos sobre os gêneros, autores e obras mais importantes, com o objetivo de informar, motivar e orientar as atividades de leitura e escrita realizadas por nossos membros.
            </p>

            <div className="container_bannernos"  align="center">
                <img
                id="imagenajustada"
                className="d-block w-100"
                src={aboutus34}
                width="400"
                height="450"
                alt="..."
                />
            
                </div>
                <br />

            <h4 id="titulo" align="left"> <b>2. Promoção da escrita



            <br />
            </b> 
            </h4>
            <br />
            <p>
            Escrever é um dos desafios intelectuais mais importantes para todas as pessoas. É um ato criativo e propositivo, que permite dar a conhecer ideias, criações e propostas, e contribui para a expansão do conhecimento e do património literário universal.
            </p>
            <p>
            Escrever com elegância, argumentos claros e riqueza linguística é uma das habilidades mais importantes que devemos desenvolver, pois disso dependem o sucesso acadêmico, profissional e social, assim como a possibilidade de publicar nossas propostas na internet, ser lidas e impactar milhões de usuários no mundo. A experiência comprova: o sucesso na sociedade tecnológica moderna depende de ter boas habilidades de escrita, de elaborar e transmitir mensagens significativas que sejam atraentes e gerem valor para os milhões de usuários da Internet que recebem informações em todos os países do mundo.
            </p>
            <p>
            Para facilitar e fortalecer as habilidades de comunicação de nossos membros, LEO criou o portal web writersleo, uma rede social especializada que permite aos membros criar seu perfil de escritor e publicar seus trabalhos em qualquer tópico ou gênero, para serem visíveis para outros membros e para pessoas de todo o mundo. Podem ser obras gratuitas ou comerciais. Você também pode organizar ou vincular grupos, postar e enviar mensagens e outras atividades de redes sociais.
            </p>
            <h3 id="titulo" align="center"> <b>CLUBLEO <br />
            Uma comunidade global, comprometida com a construção <br />
            de uma sociedade mais educada e culta




            <div align="center">
                <img
                id="imagenajustada"
                className="d-block w-100"
                src={aboutus3}
                width="400"
                height="500"
                alt="..."
                />
                </div> 


            </b> 
            </h3>
            <br />
            <h3 id="titulo" align="center"> <b>Link!! <br />
            Queremos que seja um parceiro no projeto educativo e cultural <br />
            maior do mundo

       


            </b> 
            </h3>
            <br />

                </div>
                
                
        </div>

  );
}
